import retryify from 'utils/retryify';
import { sendSystem } from '..';

/**
 * 发送会话操作
 * @date 2022-03-18
 * @param {any} conversationId:Conversation.Conversation['conversationId']
 * @param {any} assistantId:number
 * @param {any} operation:'OPEN'|'CLOSE'
 * @returns {any}
 */
const sendConvOpe = (
  conversationId: Conversation.Conversation['conversationId'],
  assistantId: number | string,
  operation: 'OPEN' | 'CLOSE',
) => {
  const data = {
    action: 'CONV_OPE',
    assistantId,
    conversationId,
    timestamp: Date.now().valueOf(),
    ope: operation,
  } as unknown as any;
  return sendSystem({
    scene: 'p2p',
    to: 'leyan',
    sendToOnlineUsersOnly: false,
    cc: true,
    content: JSON.stringify(data),
  });
};

export const sendLoginConfirm = (assistantId: number | string) => {
  const data = {
    action: 'LOGIN_CONFIRM',
    assistantId,
    timestamp: Date.now().valueOf(),
    clientType: 'WEB',
  } as unknown as any;
  return sendSystem({
    scene: 'p2p',
    to: 'leyan',
    sendToOnlineUsersOnly: false,
    cc: true,
    content: JSON.stringify(data),
  });
};

export default retryify(sendConvOpe);
